import React from 'react'
import { buildItemWidget } from '../config'
import BuildItemWidget from '../BuildItemWidget'
import './style.css'

const MobileBody = () => (
  <div className="home-mobile-body">
    <span className="home-mobile-body-build-text-back">
      Get building
    </span>
    <span className="home-mobile-body-build-text">
      You can build it with Drift
    </span>
    <div className="home-mobile-body-build-items">
    {buildItemWidget.map((item, index) => (
      <BuildItemWidget key={index} selectedBuildItemType={item.buildItemType} />
    ))}
    </div>
  </div>
)

export default MobileBody
